/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/table.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import './styles.scss'
import { TypescriptComponent } from 'components/typescriptExample'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Image, Link } from '@ta-interaktiv/contentbricks'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'

// TODO Set the correct article ID here
const ARTICLE_ID = '943358443975'

const fourColumnGrid = window.innerWidth > 1200
const twoColumnGrid = window.innerWidth > 599 && window.innerWidth < 1199
const oneColumnGrid = window.innerWidth < 600
const width500 = window.innerWidth < 1200
// const isMobileSmall = window.innerWidth < 376

const Quote = ({ children, author }) => {
  if (!children) return null
  return (
    <blockquote className='quote'>
      <p>{children}</p>
      {author && <span>{author}</span>}
    </blockquote>
  )
}

export function AppComponent() {
  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch />
      <header className='ui titleImage'>
        <div className='ui container cover'>
          <div className='ui header headline'>
            <div className='headerWrapper'>
              <h1>Was Sie über die Corona-Tests wissen sollten</h1>
              <h2>
                Bei den aktuell verschärften Massnahmen gegen die Ausbreitung
                des Coronavirus sind auch die Tests immer wieder von zentraler
                Bedeutung. Welcher Test ist wann am besten und warum muss man
                sich oft zweimal testen lassen?
              </h2>
            </div>
          </div>
        </div>
        <div className='virus' />
        <div className='Wrapper'>
          <div className='leftHand' />
          <div className='rightHand' />
        </div>
      </header>
      <div className='ui vertical fitted segment'>
        <div className='ui text container'>
          <div className='ta metainfo'>
            <div className='ta author'>Barbara Reye, Patrick Vögeli</div>
            <div className='ta updated'>Aktualisiert am 20. Dezember 2021</div>
          </div>
          <div className='ta text'>
            <p>
              Mit den hohen Fallzahlen, den bevorstehenden Festtagen und der
              drohenden Omikron-Welle werden PCR- und Antigen-Schnelltests
              nochmals wichtiger bei der Bekämpfung der Pandemie. Wir haben die
              wichtigsten Fakten zu den verschiedenen Tests zusammengestellt und
              sagen, worauf man besonders achten muss, was neu bei der Einreise
              in die Schweiz gilt und wer die Kosten für die Tests bezahlt.
            </p>
          </div>
        </div>
      </div>

      <div className='ui vertical fitted segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <h4 className='chapter'>
              {/* <b>1</b> */}
              {/* <br /> */}
              Wie oft und wann muss man sich bei der Einreise in die Schweiz
              testen lassen?
            </h4>
            <p>
              Mit wenigen Ausnahmen müssen alle Einreisenden ein
              Einreiseformular und ein negatives Testresultat vorweisen (siehe
              Grafik). Nach Konsultation der Kantone hat der Bundesrat jedoch
              das Testregime angepasst. Vor der Einreise in die Schweiz werden
              neben PCR-Tests, die nicht älter als 72 Stunden sind, nun auch
              Antigen-Schnelltests akzeptiert, die nicht älter als 24 Stunden
              sind. Bei geimpften und genesenen Personen wird auf die Pflicht
              eines zweiten Tests 4 bis 7 Tage nach der Einreise in die Schweiz
              verzichtet.
            </p>
            <h5 className='graphicTitle travel'>
              Bei der Einreise in die Schweiz gilt neu
            </h5>
            <div className='graphicSub'>Stand: 20. Dezember 2021.</div>
            <Image
              file={
                browserCheck.isMobile
                  ? require('../../images/travel-mobile.svg')
                  : require('../../images/travel-desktop.svg')
              }
              className='cbImage travel'
              // aspectRatio={browserCheck.isMobile ? '4:3' : '16:9'}
              // source='Quelle: Robert Koch Institut'
            />
            <div className='listWrapper'>
              <div className='col'>
                <div className='listTitle bold'>
                  Keine Test- und Formularpflicht für:
                </div>
                <ul>
                  <li>Chauffeurinnen und Chauffeure</li>
                  <li>Grenzgängerinnen und Grenzgänger***</li>
                  <li>Einreisende von Grenzregionen***</li>
                </ul>
              </div>
              <div className='col'>
                <div className='listTitle bold'>Keine Testpflicht für:</div>
                <ul>
                  <li>Kinder unter 16 Jahre</li>
                  <li>Personen mit Test-Dispens</li>
                  <li>Medizinische Notfälle</li>
                </ul>
              </div>
            </div>
            <div className='note travel'>
              <div>
                * PCR-Test (nicht älter als 72h) oder Antigen-Schnelltest (nicht
                älter als 24h).
              </div>
              <div>** Dieses Testergebnis muss dem Kanton gemeldet werden.</div>
              <div>
                *** Bei Einreise per Flugzeug oder Fernbus sind Test und
                Formular erforderlich.
              </div>
            </div>
            <div className='source travel'>
              Quelle: Bundesamt für Gesundheit
            </div>
          </div>
        </div>
      </div>

      <div className='ui vertical fitted segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <h4 className='chapter'>
              {/* <b>1</b> */}
              {/* <br /> */}
              Wann werden die Testkosten übernommen?
            </h4>
            <p>
              Die Kosten von gewissen Covid-19-Tests, die zu einem
              Covid-Zertifikat führen, werden neu wieder übernommen. Bezahlt
              werden Antigen-Schnelltests und Speichel-PCR-Pooltests. Nicht
              bezahlt werden Selbsttests sowie Einzel-PCR-Tests und
              Antikörpertests. Weiterhin übernommen werden die Kosten von
              Einzel-PCR-Tests bei Personen mit Krankheitssymptomen, bei
              Kontaktpersonen und nach positiven Poolproben.
            </p>
          </div>
        </div>
      </div>

      <div className='ui vertical fitted segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <h4 className='chapter'>
              {/* <b>1</b> */}
              {/* <br /> */}
              Was bedeutet 2G+ für Discos und Aktivitäten ohne Maske?
            </h4>
            <p>
              Wo weder das Maskentragen noch eine Sitzpflicht möglich ist, sind
              nur noch geimpfte und genesene Personen zugelassen, die zusätzlich
              ein negatives Testresultat vorweisen können (2G+). Diese Regel
              gilt einerseits für Discos und Bars, andererseits für Sport- und
              Kulturaktivitäten von Laien, wenn keine Maske getragen wird, wie
              etwa Blasmusikproben. Sie gilt nicht für Jugendliche bis 16 Jahre.
              Neu werden Personen, deren vollständige Impfung, Auffrischimpfung
              oder Genesung nicht länger als vier Monate zurückliegt, von dieser
              Testpflicht ausgenommen. Betriebe und Veranstaltungen, die der
              2G-Regel unterstehen, können freiwillig 2G+ anwenden und damit auf
              die Masken- und die Sitzpflicht verzichten.
            </p>
          </div>
        </div>
      </div>

      <div className='ui vertical fitted segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <h4 className='chapter'>
              {/* <b>1</b> */}
              {/* <br /> */}
              Wann ist ein Antigen-Schnelltest überhaupt sinnvoll?
            </h4>
            <p>
              Der Antigen-Schnelltest eignet sich, um sehr rasch zu erkennen, ob
              eine Person eine hohe Viruslast hat und deshalb hochansteckend
              ist. Er kann teurere PCR-Tests ersetzen und Labore entlasten.
              Dennoch ist selbst bei korrekter Anwendung die Sensitivität etwas
              geringer als beim PCR-Test. Infizierte mit sehr niedriger
              Viruslast werden dadurch möglicherweise nicht erkannt. Deshalb ist
              der PCR-Test nach wie vor der Goldstandard und dient als Kontrolle
              für Antigen-Schnelltests.
            </p>
          </div>
        </div>
      </div>

      <div className='ui vertical fitted segment'>
        <div className='ui container'>
          <h5 className='graphicTitle testmethoden'>
            Übersicht der Testmethoden
          </h5>
          {fourColumnGrid && (
            <>
              <div className='tableWrapper' id='twoColumn'>
                <div className='row header'>
                  <div className='col darkblueBorder'>
                    <div className='tableTitle'>
                      <img
                        src={require('../../images/icon-pcr.svg')}
                        className=''
                        style={{ margin: '0' }}
                      />
                      <div className='title bold darkblue'>PCR-Test</div>
                    </div>
                  </div>
                  <div className='col darkblueBorder'>
                    <div className='tableTitle'>
                      <img
                        src={require('../../images/icon-pcr-schnell.svg')}
                        className=''
                        style={{ margin: '0' }}
                      />
                      <div className='title bold darkblue'>PCR-Schnelltest</div>
                    </div>
                  </div>
                  <div className='col darkblueBorder'>
                    <div className='tableTitle'>
                      <img
                        src={require('../../images/icon-antigen.svg')}
                        className=''
                        style={{ margin: '0' }}
                      />
                      <div className='title bold darkblue'>
                        Antigen-Schnelltest
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    Bei den klassischen PCR-Tests werden die Proben in Labors
                    geschickt, um das Vorhandensein von Erbsubstanz des Erregers
                    nachzuweisen. Dazu werden zuerst bestimmte Abschnitte des
                    RNA-Erbgutmoleküls vom Virus in entsprechende DNA-Fragmente
                    umgewandelt, danach vervielfältigt und analysiert. Nach
                    Eintreffen der Probe bis zum Resultat dauert es meist 3
                    Stunden, allerdings können je nach System bis zu 1000 Proben
                    gleichzeitig getestet werden.
                  </div>
                  <div className='col'>
                    PCR-Schnelltests nutzen zwar die gleiche Methode, allerdings
                    mit speziellen Verfahren und als Einzelprobe. Manche dieser
                    Tests sind ebenso sensitiv wie die klassischen PCR-Tests.
                    Sie werden unter anderem auch als eine Art Mini-Labor
                    (Angaben unten) vermarktet, bei dem alle Reagenzien bereits
                    schon in einem Röhrchen vorhanden sind und in einem
                    kaffeemaschinen&shy;grossen Gerät ausgewertet werden. Der
                    Nachteil: Nur eine Probe aufs Mal möglich.
                  </div>
                  <div className='col'>
                    Antigen-Schnelltests können den Erreger ebenfalls direkt
                    nachweisen, zum Beispiel ein Antigen (Nucleocapsid-Protein)
                    vom Virus. Entweder werden Ergebnisse vor Ort mit
                    Einzelproben mit dem Teststreifenverfahren durchgeführt
                    (Angaben unten) oder aber eine aufgrund der Logistik
                    zeitlich etwas aufwendigere Laboranalyse auf
                    Hightech-Geräten mit bis zu 300 Proben pro Stunde
                    gleichzeitig.
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Anwendung:</div>
                        <div className='colInsideRight'>
                          für alle Personen bei Verdacht auf Infektion (vor
                          allem Spitäler, Schulen, Alten- und Pflegeheime)
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        {width500 && (
                          <div className='colInsideLeft bold'>Anwendung:</div>
                        )}

                        <div className='colInsideRight'>
                          für Einzeltests in Arztpraxen und in Spitälern
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        {width500 && (
                          <div className='colInsideLeft bold'>Anwendung:</div>
                        )}

                        <div className='colInsideRight'>
                          für die schnelle Überprüfung bei Symptomen und
                          Screening von Kontaktpersonen, potenziellen
                          Infektionsclustern (z. B. in Schulen, Alten- und
                          Pflegeheimen) sowie für Gesundheits- und
                          Pflegepersonal
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Probe:</div>
                        <div className='colInsideRight'>
                          <span>
                            Nasen-Rachen- sowie Nasen-Abstrich und Speichel (für
                            PCR-Pooltest)
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        {width500 && (
                          <div className='colInsideLeft bold'>Probe:</div>
                        )}

                        <div className='colInsideRight'>
                          Nasen-Rachen-Abstrich
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        {width500 && (
                          <div className='colInsideLeft bold'>Probe:</div>
                        )}

                        <div className='colInsideRight'>
                          Nasen-Rachen-Abstrich und Nasen-Abstrich
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Analyse:</div>
                        <div className='colInsideRight'>Labor</div>
                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        {width500 && (
                          <div className='colInsideLeft bold'>Analyse:</div>
                        )}
                        <div className='colInsideRight'>
                          ohne Labor in Arztpraxis oder im Spital
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        {width500 && (
                          <div className='colInsideLeft bold'>Analyse:</div>
                        )}
                        <div className='colInsideRight'>
                          ohne Labor direkt in Testzentren, Arztpraxen,
                          Apotheken oder Spitälern
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Genauigkeit:</div>
                        <div className='colInsideRight'>sehr hoch</div>
                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        {width500 && (
                          <div className='colInsideLeft bold'>Genauigkeit:</div>
                        )}
                        <div className='colInsideRight'>sehr hoch</div>
                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        {width500 && (
                          <div className='colInsideLeft bold'>Genauigkeit:</div>
                        )}
                        <div className='colInsideRight'>
                          geringer als PCR-Test
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Zeit:</div>
                        <div className='colInsideRight'>3 h</div>
                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        {width500 && (
                          <div className='colInsideLeft bold'>Zeit:</div>
                        )}
                        <div className='colInsideRight'>20 min</div>
                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        {width500 && (
                          <div className='colInsideLeft bold'>Zeit:</div>
                        )}
                        <div className='colInsideRight'>15 min</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className='tableWrapper second' id='twoColumn'>
                <div className='row header'>
                  <div className='col darkblueBorder'>
                    <div className='tableTitle'>
                      <img
                        src={require('../../images/icon-antigen_nase.svg')}
                        className=''
                        style={{ margin: '0' }}
                      />
                      <div className='title bold darkblue'>Selbsttest Nase</div>
                    </div>
                  </div>
                  <div className='col darkblueBorder'>
                    <div className='tableTitle'>
                      <img
                        src={require('../../images/icon-antikoerper.svg')}
                        className=''
                        style={{ margin: '0' }}
                      />
                      <div className='title bold darkblue'>
                        Antikörper-Schnelltest
                      </div>
                    </div>
                  </div>
                  <div className='col empty' />
                </div>
                <div className='row'>
                  <div className='col'>
                    Es ist auch ein Antigen-Schnelltest, bei dem die Probe aber
                    immer ein Abstrich aus der Nase ist. Bei der Entnahme der
                    Probe durch den Laien können generell mehr Fehler auftreten.
                  </div>
                  <div className='col'>
                    Antikörper-Schnelltests weisen nach, ob das Immunsystem auf
                    das Virus reagiert hat. Das ist in einem sehr späten
                    Infektionsstadium oder nach einer Infektion der Fall. Meist
                    wird nur eine Antikörperklasse, entweder IgG oder IgM,
                    erfasst. Auch hier gibt es bei den Schnelltests das
                    Teststreifenverfahren mit Ergebnis direkt vor Ort (Angaben
                    untern) oder eine aufgrund der Logistik zeitlich etwas
                    aufwendigere Laboranalyse mit mehreren Hundert Proben auf
                    einmal.
                  </div>
                  <div className='col empty' />
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Anwendung:</div>
                        <div className='colInsideRight'>
                          für alle Personen, damit sie sich regelmässig testen
                          können, auch wenn sie keine Symptome haben. Jede
                          Person soll monatlich fünf Selbsttests beziehen
                          können.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        {width500 && (
                          <div className='colInsideLeft bold'>Anwendung:</div>
                        )}
                        <div className='colInsideRight'>
                          für alle, die eine rasche Antwort wollen, ob sie mit
                          dem Erreger schon mal in Kontakt waren oder nicht
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col empty' />
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Probe:</div>
                        <div className='colInsideRight'>Nasen-Abstrich</div>
                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        {width500 && (
                          <div className='colInsideLeft bold'>Probe:</div>
                        )}
                        <div className='colInsideRight'>Blut</div>
                      </div>
                    </div>
                  </div>
                  <div className='col empty' />
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Analyse:</div>
                        <div className='colInsideRight'>
                          ohne Labor direkt vor Ort
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        {width500 && (
                          <div className='colInsideLeft bold'>Analyse:</div>
                        )}
                        <div className='colInsideRight'>
                          vor Ort ohne Instrumente etwa in Spitälern, Arztpraxen
                          oder Apotheken
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col empty' />
                </div>
                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Genauigkeit:</div>
                        <div className='colInsideRight'>
                          mit Symptomen hoch, ohne Symptome vermutlich geringer
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        {width500 && (
                          <div className='colInsideLeft bold'>Genauigkeit:</div>
                        )}
                        <div className='colInsideRight'>hoch</div>
                      </div>
                    </div>
                  </div>
                  <div className='col empty' />
                </div>
                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Zeit:</div>
                        <div className='colInsideRight'>15 min</div>
                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        {width500 && (
                          <div className='colInsideLeft bold'>Zeit:</div>
                        )}
                        <div className='colInsideRight'>20 min</div>
                      </div>
                    </div>
                  </div>
                  <div className='col empty' />
                </div>
              </div>
            </>
          )}
          {twoColumnGrid && (
            <>
              <div className='tableWrapper' id='twoColumn'>
                <div className='row header'>
                  <div className='col darkblueBorder'>
                    <div className='tableTitle'>
                      <img
                        src={require('../../images/icon-pcr.svg')}
                        className=''
                        style={{ margin: '0' }}
                      />
                      <div className='title bold darkblue'>PCR-Test</div>
                    </div>
                  </div>
                  <div className='col darkblueBorder'>
                    <div className='tableTitle'>
                      <img
                        src={require('../../images/icon-pcr-schnell.svg')}
                        className=''
                        style={{ margin: '0' }}
                      />
                      <div className='title bold darkblue'>PCR-Schnelltest</div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    Bei den klassischen PCR-Tests werden die Proben in Labors
                    geschickt, um das Vorhandensein von Erbsubstanz des Erregers
                    nachzuweisen. Dazu werden zuerst bestimmte Abschnitte des
                    RNA-Erbgutmoleküls vom Virus in entsprechende DNA-Fragmente
                    umgewandelt, danach vervielfältigt und analysiert. Nach
                    Eintreffen der Probe bis zum Resultat dauert es meist 3
                    Stunden, allerdings können je nach System bis zu 1000 Proben
                    gleichzeitig getestet werden.
                  </div>
                  <div className='col'>
                    PCR-Schnelltests nutzen zwar die gleiche Methode, allerdings
                    mit speziellen Verfahren und als Einzelprobe. Manche dieser
                    Tests sind ebenso sensitiv wie die klassischen PCR-Tests.
                    Sie werden unter anderem auch als eine Art Mini-Labor
                    (Angaben unten) vermarktet, bei dem alle Reagenzien bereits
                    schon in einem Röhrchen vorhanden sind und in einem
                    kaffeemaschinen&shy;grossen Gerät ausgewertet werden. Der
                    Nachteil: Nur eine Probe aufs Mal möglich.
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Anwendung:</div>
                        <div className='colInsideRight'>
                          für alle Personen bei Verdacht auf Infektion (vor
                          allem Spitäler, Schulen, Alten- und Pflegeheime)
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        {width500 && (
                          <div className='colInsideLeft bold'>Anwendung:</div>
                        )}

                        <div className='colInsideRight'>
                          für Einzeltests in Arztpraxen und in Spitälern
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Probe:</div>
                        <div className='colInsideRight'>
                          <span>
                            Nasen-Rachen- sowie Nasen-Abstrich und Speichel (für
                            PCR-Pooltest)
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        {width500 && (
                          <div className='colInsideLeft bold'>Probe:</div>
                        )}

                        <div className='colInsideRight'>
                          Nasen-Rachen-Abstrich
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Analyse:</div>
                        <div className='colInsideRight'>Labor</div>
                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        {width500 && (
                          <div className='colInsideLeft bold'>Analyse:</div>
                        )}
                        <div className='colInsideRight'>
                          ohne Labor in Arztpraxis oder im Spital
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Genauigkeit:</div>
                        <div className='colInsideRight'>sehr hoch</div>
                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        {width500 && (
                          <div className='colInsideLeft bold'>Genauigkeit:</div>
                        )}
                        <div className='colInsideRight'>sehr hoch</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Zeit:</div>
                        <div className='colInsideRight'>3 h</div>
                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        {width500 && (
                          <div className='colInsideLeft bold'>Zeit:</div>
                        )}
                        <div className='colInsideRight'>20 min</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className='tableWrapper second' id='twoColumn'>
                <div className='row header'>
                  <div className='col darkblueBorder'>
                    <div className='tableTitle'>
                      <img
                        src={require('../../images/icon-antigen.svg')}
                        className=''
                        style={{ margin: '0' }}
                      />
                      <div className='title bold darkblue'>
                        Antigen-Schnelltest
                      </div>
                    </div>
                  </div>
                  <div className='col darkblueBorder'>
                    <div className='tableTitle'>
                      <img
                        src={require('../../images/icon-antigen_nase.svg')}
                        className=''
                        style={{ margin: '0' }}
                      />
                      <div className='title bold darkblue'>Selbsttest Nase</div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    Antigen-Schnelltests können den Erreger ebenfalls direkt
                    nachweisen, zum Beispiel ein Antigen (Nucleocapsid-Protein)
                    vom Virus. Entweder werden Ergebnisse vor Ort mit
                    Einzelproben mit dem Teststreifenverfahren durchgeführt
                    (Angaben unten) oder aber eine aufgrund der Logistik
                    zeitlich etwas aufwendigere Laboranalyse auf
                    Hightech-Geräten mit bis zu 300 Proben pro Stunde
                    gleichzeitig.
                  </div>
                  <div className='col'>
                    Es ist auch ein Antigen-Schnelltest, bei dem die Probe aber
                    immer ein Abstrich aus der Nase ist. Bei der Entnahme der
                    Probe durch den Laien können generell mehr Fehler auftreten.
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Anwendung:</div>
                        <div className='colInsideRight'>
                          für die schnelle Überprüfung bei Symptomen und
                          Screening von Kontaktpersonen, potenziellen
                          Infektionsclustern (z. B. in Schulen, Alten- und
                          Pflegeheimen) sowie für Gesundheits- und
                          Pflegepersonal
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        {width500 && (
                          <div className='colInsideLeft bold'>Anwendung:</div>
                        )}
                        <div className='colInsideRight'>
                          für alle Personen, damit sie sich regelmässig testen
                          können, auch wenn sie keine Symptome haben. Jede
                          Person soll monatlich fünf Selbsttests beziehen
                          können.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Probe:</div>
                        <div className='colInsideRight'>
                          Nasen-Rachen-Abstrich und Nasen-Abstrich
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        {width500 && (
                          <div className='colInsideLeft bold'>Probe:</div>
                        )}
                        <div className='colInsideRight'>Nasen-Abstrich</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Analyse:</div>
                        <div className='colInsideRight'>
                          ohne Labor direkt in Testzentren, Arztpraxen,
                          Apotheken oder Spitälern
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        {width500 && (
                          <div className='colInsideLeft bold'>Analyse:</div>
                        )}
                        <div className='colInsideRight'>
                          ohne Labor direkt vor Ort
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Genauigkeit:</div>
                        <div className='colInsideRight'>
                          geringer als PCR-Test
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        {width500 && (
                          <div className='colInsideLeft bold'>Genauigkeit:</div>
                        )}
                        <div className='colInsideRight'>
                          mit Symptomen hoch, ohne Symptome vermutlich geringer
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Zeit:</div>
                        <div className='colInsideRight'>15 min</div>
                      </div>
                    </div>
                  </div>
                  <div className='col'>
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        {width500 && (
                          <div className='colInsideLeft bold'>Zeit:</div>
                        )}
                        <div className='colInsideRight'>15 min</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className='tableWrapper third' id='twoColumn'>
                <div className='row header'>
                  <div className='col darkblueBorder'>
                    <div className='tableTitle'>
                      <img
                        src={require('../../images/icon-antikoerper.svg')}
                        className=''
                        style={{ margin: '0' }}
                      />
                      <div className='title bold darkblue'>
                        Antikörper-Schnelltest
                      </div>
                    </div>
                  </div>
                  <div className='col empty' />
                </div>
                <div className='row'>
                  <div className='col'>
                    Antikörper-Schnelltests weisen nach, ob das Immunsystem auf
                    das Virus reagiert hat. Das ist in einem sehr späten
                    Infektionsstadium oder nach einer Infektion der Fall. Meist
                    wird nur eine Antikörperklasse, entweder IgG oder IgM,
                    erfasst. Auch hier gibt es bei den Schnelltests das
                    Teststreifenverfahren mit Ergebnis direkt vor Ort (Angaben
                    untern) oder eine aufgrund der Logistik zeitlich etwas
                    aufwendigere Laboranalyse mit mehreren Hundert Proben auf
                    einmal.
                  </div>
                  <div className='col empty' />
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Anwendung:</div>
                        <div className='colInsideRight'>
                          für alle, die eine rasche Antwort wollen, ob sie mit
                          dem Erreger schon mal in Kontakt waren oder nicht
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col empty' />
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Probe:</div>
                        <div className='colInsideRight'>Blut</div>
                      </div>
                    </div>
                  </div>
                  <div className='col empty' />
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Analyse:</div>
                        <div className='colInsideRight'>
                          vor Ort ohne Instrumente etwa in Spitälern, Arztpraxen
                          oder Apotheken
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col empty' />
                </div>
                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Genauigkeit:</div>
                        <div className='colInsideRight'>hoch</div>
                      </div>
                    </div>
                  </div>
                  <div className='col empty' />
                </div>
                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Zeit:</div>
                        <div className='colInsideRight'>20 min</div>
                      </div>
                    </div>
                  </div>
                  <div className='col empty' />
                </div>
              </div>
            </>
          )}
          {oneColumnGrid && (
            <>
              <div className='tableWrapper' id='oneColumn'>
                <div className='row header'>
                  <div className='col darkblueBorder'>
                    <div className='tableTitle'>
                      <img
                        src={require('../../images/icon-pcr.svg')}
                        className=''
                        style={{ margin: '0' }}
                      />
                      <div className='title bold darkblue'>PCR-Test</div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    Bei den klassischen PCR-Tests werden die Proben in Labors
                    geschickt, um das Vorhandensein von Erbsubstanz des Erregers
                    nachzuweisen. Dazu werden zuerst bestimmte Abschnitte des
                    RNA-Erbgutmoleküls vom Virus in entsprechende DNA-Fragmente
                    umgewandelt, danach vervielfältigt und analysiert. Nach
                    Eintreffen der Probe bis zum Resultat dauert es meist 3
                    Stunden, allerdings können je nach System bis zu 1000 Proben
                    gleichzeitig getestet werden.
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Anwendung:</div>
                        <div className='colInsideRight'>
                          für alle Personen bei Verdacht auf Infektion (vor
                          allem Spitäler, Schulen, Alten- und Pflegeheime)
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Probe:</div>
                        <div className='colInsideRight'>
                          <span>
                            Nasen-Rachen- sowie Nasen-Abstrich und Speichel (für
                            PCR-Pooltest)
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Analyse:</div>
                        <div className='colInsideRight'>Labor</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Genauigkeit:</div>
                        <div className='colInsideRight'>sehr hoch</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Zeit:</div>
                        <div className='colInsideRight'>3 h</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='tableWrapper' id='oneColumn'>
                <div className='row header'>
                  <div className='col darkblueBorder'>
                    <div className='tableTitle'>
                      <img
                        src={require('../../images/icon-pcr-schnell.svg')}
                        className=''
                        style={{ margin: '0' }}
                      />
                      <div className='title bold darkblue'>PCR-Schnelltest</div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    PCR-Schnelltests nutzen zwar die gleiche Methode, allerdings
                    mit speziellen Verfahren und als Einzelprobe. Manche dieser
                    Tests sind ebenso sensitiv wie die klassischen PCR-Tests.
                    Sie werden unter anderem auch als eine Art Mini-Labor
                    (Angaben unten) vermarktet, bei dem alle Reagenzien bereits
                    schon in einem Röhrchen vorhanden sind und in einem
                    kaffeemaschinen&shy;grossen Gerät ausgewertet werden. Der
                    Nachteil: Nur eine Probe aufs Mal möglich.
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Anwendung:</div>
                        <div className='colInsideRight'>
                          für Einzeltests in Arztpraxen und in Spitälern
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Probe:</div>
                        <div className='colInsideRight'>
                          Nasen-Rachen-Abstrich
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Analyse:</div>
                        <div className='colInsideRight'>
                          ohne Labor in Arztpraxis oder im Spital
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Genauigkeit:</div>
                        <div className='colInsideRight'>sehr hoch</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Zeit:</div>
                        <div className='colInsideRight'>20 min</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='tableWrapper' id='oneColumn'>
                <div className='row header'>
                  <div className='col darkblueBorder'>
                    <div className='tableTitle'>
                      <img
                        src={require('../../images/icon-antigen.svg')}
                        className=''
                        style={{ margin: '0' }}
                      />
                      <div className='title bold darkblue'>
                        Antigen-Schnelltest
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    Antigen-Schnelltests können den Erreger ebenfalls direkt
                    nachweisen, zum Beispiel ein Antigen (Nucleocapsid-Protein)
                    vom Virus. Entweder werden Ergebnisse vor Ort mit
                    Einzelproben mit dem Teststreifenverfahren durchgeführt
                    (Angaben unten) oder aber eine aufgrund der Logistik
                    zeitlich etwas aufwendigere Laboranalyse auf
                    Hightech-Geräten mit bis zu 300 Proben pro Stunde
                    gleichzeitig.
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Anwendung:</div>
                        <div className='colInsideRight'>
                          für die schnelle Überprüfung bei Symptomen und
                          Screening von Kontaktpersonen, potenziellen
                          Infektionsclustern (z. B. in Schulen, Alten- und
                          Pflegeheimen) sowie für Gesundheits- und
                          Pflegepersonal
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Probe:</div>
                        <div className='colInsideRight'>
                          Nasen-Rachen-Abstrich und Nasen-Abstrich
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Analyse:</div>
                        <div className='colInsideRight'>
                          ohne Labor direkt in Testzentren, Arztpraxen,
                          Apotheken oder Spitälern
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Genauigkeit:</div>
                        <div className='colInsideRight'>
                          geringer als PCR-Test
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Zeit:</div>
                        <div className='colInsideRight'>15 min</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='tableWrapper' id='oneColumn'>
                <div className='row header'>
                  <div className='col darkblueBorder'>
                    <div className='tableTitle'>
                      <img
                        src={require('../../images/icon-antigen_nase.svg')}
                        className=''
                        style={{ margin: '0' }}
                      />
                      <div className='title bold darkblue'>Selbsttest Nase</div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    Es ist auch ein Antigen-Schnelltest, bei dem die Probe aber
                    immer ein Abstrich aus der Nase ist. Bei der Entnahme der
                    Probe durch den Laien können generell mehr Fehler auftreten.
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Anwendung:</div>
                        <div className='colInsideRight'>
                          für alle Personen, damit sie sich regelmässig testen
                          können, auch wenn sie keine Symptome haben. Jede
                          Person soll monatlich fünf Selbsttests beziehen
                          können.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Probe:</div>
                        <div className='colInsideRight'>Nasen-Abstrich</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Analyse:</div>
                        <div className='colInsideRight'>
                          ohne Labor direkt vor Ort
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Genauigkeit:</div>
                        <div className='colInsideRight'>hoch</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Zeit:</div>
                        <div className='colInsideRight'>15 min</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='tableWrapper' id='oneColumn'>
                <div className='row header'>
                  <div className='col darkblueBorder'>
                    <div className='tableTitle'>
                      <img
                        src={require('../../images/icon-antikoerper.svg')}
                        className=''
                        style={{ margin: '0' }}
                      />
                      <div className='title bold darkblue'>
                        Antikörper-Schnelltest
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    Antikörper-Schnelltests weisen nach, ob das Immunsystem auf
                    das Virus reagiert hat. Das ist in einem sehr späten
                    Infektionsstadium oder nach einer Infektion der Fall. Meist
                    wird nur eine Antikörperklasse, entweder IgG oder IgM,
                    erfasst. Auch hier gibt es bei den Schnelltests das
                    Teststreifenverfahren mit Ergebnis direkt vor Ort (Angaben
                    untern) oder eine aufgrund der Logistik zeitlich etwas
                    aufwendigere Laboranalyse mit mehreren Hundert Proben auf
                    einmal.
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Anwendung:</div>
                        <div className='colInsideRight'>
                          für alle, die eine rasche Antwort wollen, ob sie mit
                          dem Erreger schon mal in Kontakt waren oder nicht
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Probe:</div>
                        <div className='colInsideRight'>Blut</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Analyse:</div>
                        <div className='colInsideRight'>
                          vor Ort ohne Instrumente etwa in Spitälern, Arztpraxen
                          oder Apotheken
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Genauigkeit:</div>
                        <div className='colInsideRight'>hoch</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    {' '}
                    <div className='rowInside'>
                      <div className='columnOutside'>
                        <div className='colInsideLeft bold'>Zeit:</div>
                        <div className='colInsideRight'>20 min</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      <div className='ui vertical fitted segment'>
        <div className='ui ta text container'>
          <h4 className='chapter'>
            {/* <b>1</b> */}
            {/* <br /> */}
            Wie zuverlässig ist ein Antigen-Schnelltest?
          </h4>
          <p>
            Antigen-Schnelltests können zu einer höheren Anzahl falsch negativer
            bzw. falsch positiver Testergebnisse führen. Dies hängt aber davon
            ab, wie hoch die Sensitivität und die Spezifität des jeweiligen
            Testkits sind (siehe Grafik). Deshalb ist es wichtig, bei jedem
            positiven Ergebnis nachfolgend immer einen im Vergleich technisch
            aufwendigeren PCR-Test zur Bestätigung zu machen. Und bei einem
            negativen Ergebnis möglichst zwei bis vier Tage später den
            Antigen-Schnelltest zu wiederholen.
          </p>
        </div>
      </div>

      <div
        className='ui vertical fitted segment'
        style={{ backgroundColor: '#EFECE0' }}
      >
        <div
          className='ui text container'
          style={{ marginTop: '1rem', marginBottom: '1rem' }}
        >
          <div className='ta text'>
            {/* <h4 className='graphicTitle'>
              Wie zuverlässig sind Antigen-Schnelltests
            </h4>
            <div className='graphicSub'>
              Diese Tests sind sehr hilfreich für den Nachweis in den ersten
              Tagen nach Symptombeginn und für Aussagen über die
              Ansteckungsgefahr, aber nicht ganz so genau wie PCR-Tests.
            </div> */}

            <Image
              file={
                browserCheck.isMobile
                  ? require('../../images/flussdiagramm-antigentest-mobile.svg')
                  : require('../../images/flussdiagramm-antigentest-desktop.svg')
              }
              className='cbImage flussdiagramm'
              // aspectRatio={browserCheck.isMobile ? '4:3' : '16:9'}
              // source='Quelle: Robert Koch Institut'
            />
            <div className='graphicSub flussdiagramm'>
              <div className='calcWrapper'>
                <div className='row'>
                  <div className='colAntigen divBox'>
                    <div className='divLeft' />
                    <div className='divRight' />
                  </div>
                  <div className='colAntigen divBox'>
                    <div className='divLeft' />
                    <div className='divRight' />
                  </div>
                </div>
                <div className='row'>
                  <div className='colAntigen divBox'>
                    <div className='divLeft' />
                    <div className='divRight' />
                  </div>
                  <div className='colAntigen textBox'>
                    <div className='text'>
                      Wie wahrscheinlich bin ich aktut infiziert, wenn ich ein
                      negatives Testergebnis habe:{' '}
                      <span className='number petrol bold'>2,2%</span>
                    </div>
                  </div>
                  <div className='number petrol bold' />
                </div>
                <div className='row'>
                  <div className='colAntigen textBox'>
                    <div className='text'>
                      Wie wahrscheinlich bin ich akut infiziert, wenn ich ein
                      positives Testergebnis habe:{' '}
                      <span className='number red bold'>81,6%</span>
                    </div>
                  </div>
                  {/* <div className='calcDescription'>(980 positive Tests total/ 800 davon sind richtig = 81,6%)</div> */}
                </div>
              </div>
              <br />
              <p>
                Die <span className='bold'>Sensitivität</span> und{' '}
                <span className='bold'>Spezifität</span> beschreiben wie gut ein
                Test ist. Die Sensitivität ist der Anteil der Personen mit
                positivem Testergebnis unter den Infizierten. Die Spezifität ist
                der Anteil der Personen mit negativem Testergebnis unter den
                Nicht-Infizierten.
              </p>
              {/* <p>
                <span className='bold'>Rechenbeispiel:</span> 1000 von 10’000
                Personen sind tatsächlich infiziert. Antigen-Schnelltest hat
                eine Sensitivität von 80% und Spezifität von 98%.
                <br />
                Sensitivität: 1000 Infizierte (davon 800 richtig positiv / 200
                falsch negativ)
                <br />
                Spezifität: 9000 Nicht-Infizierte (davon 8820 richtig negativ /
                180 falsch positiv)
              </p> */}
            </div>
          </div>
        </div>
      </div>

      <div className='ui vertical fitted segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <h4 className='chapter'>
              {/* <b>1</b> */}
              {/* <br /> */}
              Wie lang fällt ein PCR-Test bei Genesenen positiv aus?
            </h4>
            <p>
              Darüber lässt sich pauschal keine Aussage machen. Verschiedene
              Studien zeigen, dass ein PCR-Test in seltenen Fällen auch noch 20
              bis 30 Tage nach Beginn der Infektion positiv ausfällt, weil noch
              sogenannte Virustrümmer in der Probe vorhanden sind. Anders ist es
              bei einem Antigen-Schnelltest, da er nur während eines kurzen
              Zeitfensters die Infektion anzeigt. Durch die Omikron-Variante ist
              jedoch die Wahrscheinlichkeit, sich zu einem späteren Zeitpunkt
              nochmals neu zu infizieren, im Vergleich zur Delta-Variante
              deutlich gestiegen.
            </p>

            <h5 className='graphicTitle abstrich'>
              Wann ist welcher Test am besten?
            </h5>
            <Image
              file={
                browserCheck.isMobile
                  ? require('../../images/timeline-mobile.svg')
                  : require('../../images/timeline.svg')
              }
              className='cbImage timeline'
              // aspectRatio={browserCheck.isMobile ? '4:3' : '16:9'}
              // source='Quellen: «Süddeutsche Zeitung», Robert Koch Institut, Abbott'
            />
          </div>
        </div>
      </div>

      <div className='ui vertical fitted segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <h4 className='chapter'>
              {/* <b>1</b> */}
              {/* <br /> */}
              Kann ein Antikörper-Schnelltest aussagen, ob Infizierte immer noch
              ansteckend sind?
            </h4>
            <p>
              Nein. Das Vorhandensein von Antikörpern im Blut zeigt lediglich
              an, dass eine Person bereits mit dem Virus in Kontakt war oder
              geimpft wurde. Über den Zeitpunkt der zurückliegenden Infektion
              können Antikörperschnelltests keine Aussagen machen. Zudem lässt
              sich damit auch nicht feststellen, ob eine aktuelle Reinfektion
              vorhanden ist.
            </p>
          </div>
        </div>
      </div>

      <div className='ui vertical fitted segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <h4 className='chapter'>
              {/* <b>1</b> */}
              {/* <br /> */}
              Sind gepoolte PCR-Speicheltests besser als Antigen-Schnelltests?
            </h4>
            <p>
              Generell eignen sich solche einfach durchzuführenden Pooltests vor
              allem für Betriebe, Schulen oder Gesundheitseinrichtungen. Nach
              Angaben des BAG sind PCR-Pooltests im Vergleich zu
              Antigen-Schnelltests zuverlässiger und erkennen auch Infektionen
              früher. So können im Speichel mithilfe der PCR-Pooltests positive
              Fälle sogar bis zu 4 Tage vor den Symptomen identifiziert werden.
              Das Pooling und die Analyse dauern in der Regel insgesamt 8 bis 24
              Stunden. Dagegen liefern Antigen-Schnelltests sofort ein Resultat,
              um in den ersten 4 Tagen der Erkrankung schnell festzustellen, ob
              jemand mit grippeähnlichen Symptome sich tatsächlich mit
              Sars-CoV-2 infiziert hat oder nicht.
            </p>
          </div>
        </div>

        <Image
          file={require('../../images/spucktest-schule.jpg')}
          className='cbImage schulklasse'
          aspectRatio={browserCheck.isMobile ? '4:3' : '16:9'}
          source='Beim wöchentlichen PCR-Speichelpooltest nehmen Schülerinnen und Schüler der Kantonsschule Wiedikon in Zürich eine salzige Flüssigkeit für eine Minute in den Mund, um Speichel zu sammeln. Foto: KEYSTONE/Gaetan Bally'
        />
      </div>

      <div className='ui vertical fitted segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <h4 className='chapter'>
              {/* <b>1</b> */}
              {/* <br /> */}
              Können alle an einem PCR-Pooltest teilnehmen?
            </h4>
            <p>
              Vom BAG werden gepoolte PCR-Speicheltests jetzt neu auch für
              symptomlose Einzelpersonen gefördert; sie sind die empfohlene
              Testart für Covid-Zertifikate für Getestete anstelle eines
              Antigen-Schnelltests. Denn statt eines langen Stäbchens in der
              Nase braucht es bei einem gepoolten PCR-Speicheltest lediglich
              etwas Spucke. Bei den teilnehmenden Teststellen des Projekts{' '}
              <Link allowWordWrap href='https://www.pooltests.ch/de'>
                Pooltest für alle
              </Link>
              , bei dem unter anderem Apotheken, Arztpraxen, Spitex, Labore oder
              Testzentren mitmachen, können die Proben abgegeben werden.
            </p>
            <p>
              Bei einem negativen Resultat ist das Covid-Zertifikat dann 72
              Stunden ab Speichelabgabe gültig. Bei einem positiven Resultat
              werden die getesteten Personen aus der Gruppe per E-Mail
              informiert und müssen zu einer individuellen Nachtestung (PCR oder
              Antigen-Schnelltest). Falls der Nachtest negativ ist, stellt dann
              die jeweilige Teststelle ein Covid-Zertifikat aus.
            </p>
          </div>
        </div>
      </div>
      <div className='ui vertical fitted segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <h4 className='chapter'>
              {/* <b>1</b> */}
              {/* <br /> */}
              Lässt sich die neue Omikron-Variante mit einem gewöhnlichen
              PCR-Test feststellen?
            </h4>
            <p>
              Zum Nachweis der Varianten muss man entweder auf eine
              Sequenzierung zurückgreifen oder einen speziellen PCR-Test
              verwenden, der die verschiedenen Mutationen der jeweiligen
              Varianten identifiziert. Für die Omikron-Variante hat die
              Roche-Tochterfirma TIB Molbiol kürzlich ein Testkit zu
              Forschungszwecken entwickelt. Zudem gibt es weitere Testsets, die
              eine der Mutationen der Omikron-Variante nachweisen und so als
              Hinweis für die weitere Identifizierung dienen können.
            </p>
          </div>
        </div>
      </div>

      <div className='ui vertical fitted segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <h4 className='chapter'>
              {/* <b>1</b> */}
              {/* <br /> */}
              Kann ein Antigen-Schnelltest kurz nach der mRNA-Impfung auch
              positiv sein?
            </h4>
            <p>
              Nein. Denn ein Antigen-Schnelltest reagiert auf das
              Nucleocapsid-Protein des Virus in einer auf den Teststreifen
              getropften Probe. Nach einer mRNA-Impfung erzeugen die Zellen
              dagegen das Spike-Protein des Virus, dass für die Schnelltests
              nicht relevant ist.
            </p>
          </div>
        </div>
      </div>

      {/* <div className='ui vertical fitted segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              Die Streifen-Schnelltests für Antigene sehen fast wie diejenigen
              von Schwangerschaftstests aus, der PCR-Schnelltest ist dagegen ein
              kleines «Labor im Röhrchen». Die Antigen-Schnelltests und
              PCR-Schnelltests benötigen zum Beispiel Abstriche aus dem
              Nasen-Rachen-Raum. Inzwischen gibt es aber auch Tests mit Speichel
              oder nur mit einem Nasen-Abstrich. Geplant sind in Zukunft auch
              Selbsttest, die das Bundesamt für Gesundheit aber bisher noch
              nicht genehmigt hat.
            </p>
            <h4 className='graphicTitle abstrich'>
              Nasen-Rachen-Abstrich für eine Covid-19-Diagnostik
            </h4>
            <Image
              file={require('../../images/nasen-rachen-abstrich-desktop.svg')}
              className='cbImage abstrich'
              aspectRatio={browserCheck.isMobile ? '4:3' : '16:9'}
            />

            <ol className='simple-list'>
              <li>Nasenhöhle</li>
              <li>Nasenrachen</li>
              <li>Mundrachen</li>
            </ol>
            <p>
              Wie aussagekräftig, präzis und teuer diese unterschiedlichen
              Methoden sind, zeigt ein Vergleich der verschiedenen Schnelltests
              mit dem klassischen PCR-Test. Der Antigen-Schnelltest ist zum
              Beispiel ein einfaches Verfahren, um zu erkennen, ob eine Person
              eine hohe Viruslast hat und deshalb hochansteckend ist. Er könnte
              teilweise teurere PCR-Tests ersetzen und Labore entlasten − etwa
              in Schulen, Pflegeheimen oder bei Reiserückkehrern. Dennoch ist
              selbst bei korrekter Anwendung die Sensitivität etwas geringer als
              beim PCR-Test. Infizierte mit sehr niedriger Viruslast werden
              dadurch möglicherweise nicht erkannt.
            </p>
          </div>
        </div>
      </div> */}

      <Footer
        articleId={ARTICLE_ID}
        questions={[
          'Wie informativ war der Beitrag?',
          'Wie gefällt Ihnen die Gestaltung?'
        ]}
        credits={[
          ['Recherche und Text', 'Barbara Reye'],
          ['Umsetzung', 'Patrick Vögeli'],
          [
            'Quellen',
            'Robert Koch-Institut, Roche, Universität Zürich, EPFL, Covid-19 Science Taskforce, BAG'
          ]
        ]}
      />
    </div>
  )
}
